export const fr = {
    preparation: "Chargement en cours"
};
